module.exports = __webpack_public_path__ + "static/media/select_option.c44b77af.svg";